// extracted by mini-css-extract-plugin
module.exports = {"Container":"Container-MnlGa","Message":"Message-3590S"};